module.exports = __webpack_public_path__ + "static/media/ebuilt-promo-video-background.3b5e16c0.png";